import {
    Routes, Route, Navigate,
} from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LogoutWarning from '../../components/LogoutWarning';
import ScrollToTop from '../../components/ScrollToTop';
import BiddingList from '../BiddingList';
import AuditReport from '../AuditReport';
import ArchiveList from '../ArchiveList';
import BidProfileEdit from '../BidProfileEdit';
import { UPDATE_MANAGER_APP_DATA } from '../store/appData';

// Application Styles
import './App.scss';

function App() {
    /** @type {ShiftBidding.ManagerStore} */
    // @ts-ignore
    const { bidProfileDraft, bidProfile } = useSelector((state) => state);
    const isBiddingSelected = bidProfileDraft.id !== '' || bidProfile.id !== '';
    const dispatch = useDispatch();
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'manager.common' });
    useEffect(() => {
        const path = window.location.pathname;
        let currentPageName;
        switch (path) {
            case '/Manager/audit':
                currentPageName = t('audit');
                break;
            case '/Manager/archive':
                currentPageName = t('archive');
                break;
            default:
                currentPageName = t('manageBids');
                break;
        }
        dispatch({
            type: UPDATE_MANAGER_APP_DATA,
            payload: {
                pageName: currentPageName,
            },
        });
    }, [t]);
    return (
        <>
            <LogoutWarning />
            <ScrollToTop />
            <Routes>
                <Route
                    path=""
                    element={<BiddingList />}
                />
                <Route
                    path="form"
                    element={isBiddingSelected ? <BidProfileEdit /> : <Navigate to="/manager" />}
                />
                <Route
                    path="audit"
                    element={<AuditReport />}
                />
                <Route
                    path="archive"
                    element={<ArchiveList />}
                />
            </Routes>
        </>
    );
}

export default (App);
